import React from "react";
import ContentForPage from "../../containers/ContentForPage";
import PageLayout from "../UI/PageLayout";
import MarketingBreakdownDropdowns from "./MarketingReportingPageDropdowns";
import CustomCategoryDropdowns from "../UI/CustomCategoryDropdowns";

const MarketingReportingOverallPage = () => {
  return (
    <PageLayout
      title={"Marketing Reporting"}
      subTitle={"Overview"}
      dropdowns={<><MarketingBreakdownDropdowns /><CustomCategoryDropdowns /></>}
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <ContentForPage pageName={"marketing_reporting"} />
        </div>
      }
    />
  );
};

export default MarketingReportingOverallPage;
